<template>
	<div style="min-height:60vh">
		<div class="noresult-dw">
			<searchzj ref="nosearch"></searchzj>
		</div>
		<div
			class="history-con-one"
			@click.stop="toiInfoDetail(item.id)"
			v-for="(item, index) in infolist"
			:key="index"
		>
			<div class="history-con-one-left">
				<p class="history-con-one-left-p">{{item.title}}</p>
				<p class="history-con-one-left-p1">{{item.desc}}</p>
				<div class="history-con-one-left-div">
					<div class="history-con-one-left-div-left">
						<p>发布：{{item.publish_name}}</p>
						<p>{{item.create_time}}</p>
						<div>
							<img src="../../img/ll.png" alt />
							<p>{{item.hot}}</p>
						</div>
					</div>
					<div class="history-con-one-left-div-right">
						<p>
							来自：
							<span>{{item.cate.title}}</span>
						</p>
					</div>
				</div>
			</div>
			<div class="history-con-one-right">
				<img :src="item.logo" alt />
			</div>
		</div>
		<publicpaging></publicpaging>
	</div>
</template>

<script>
	import publicpaging from "../publicpaging.vue";
	import searchzj from "../searchzj.vue";
	export default {
		name: "App",
		props: ["flag"],
		components: {
			publicpaging,
			searchzj
		},
		data() {
			return {
				title: "",
				infolist: []
			};
		},

		methods: {
			toiInfoDetail(id) {
				this.$router.push({
					name: "infoDetail",
					query: { id: id }
				});
			},
			getsearch(title) {
				this.$http.get(`search/show/?type=article&title=${title}`).then(res => {
					if (res.body.code == 1) {
						this.infolist = res.body.data;
						if (res.body.msg == "暂无此数据") {
							this.$refs.nosearch.setnosearchshow(true);
						} else {
							this.$refs.nosearch.setnosearchshow(false);
						}
					}
				});
			}
		},
		created() {
			if (this.$route.query.searchtitle) {
				this.getsearch(this.$route.query.searchtitle);
			}
		}
	};
</script>

<style>
	.history-con-one {
		width: 850px;
		height: 100px;
		display: flex;
		justify-content: space-between;
		margin-top: 40px;
	}

	.history-con-one-right {
		width: 160px;
		height: 100px;
		margin-left: 80px;
	}

	.history-con-one-right img {
		width: 100%;
		height: 100%;
		border-radius: 8px;
	}

	.history-con-one-left-p {
		width: 600px;
		font-size: 20px;
		color: #28a3b1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		cursor: pointer;
	}

	.history-con-one-left-p1 {
		width: 600px;
		font-size: 14px;
		color: #808080;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-top: 20px;
	}

	.history-con-one-left-p2 {
		width: 960px;
		font-size: 20px;
		color: #cccccc;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.history-con-one-left-p3 {
		width: 960px;
		font-size: 20px;
		color: #212121;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.history-con-one-left-div {
		display: flex;
		justify-content: space-between;
		margin-top: 18px;
	}

	.history-con-one-left-div-left {
		display: flex;
	}

	.history-con-one-left-div-left p {
		font-size: 14px;
		color: #808080;
		margin-right: 30px;
	}

	.history-con-one-left-div-left div {
		display: flex;
		align-items: center;
	}

	.history-con-one-left-div-left > div > img {
		width: 16px;
		height: 12px;
		margin-right: 3px;
	}

	.history-con-one-left-div-left > div > p {
		font-size: 14px;
		color: #808080;
	}

	.history-con-one-left-div-right p {
		font-size: 14px;
		color: #808080;
	}

	.history-con-one-left-div-right > p > span {
		font-size: 14px;
		color: #212121;
	}
</style>



// WEBPACK FOOTER //
// src/components/search/searchzixun.vue